import { faTimes, faWifiSlash } from '@fortawesome/pro-solid-svg-icons';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { IconButton } from '#src/atoms/buttons/IconButton/index.tsx';
import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { Popup } from '#src/atoms/layout/Popup/index.tsx';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { BodyS } from '#src/atoms/typography/index.tsx';
import { useIsMobileApp } from '#src/hooks/useIsMobileApp.ts';

const Wrapper = styled(Horizontal).attrs({ gap: 2 })`
  color: var(--c-white);
  padding: var(--double-unit);
  border-radius: var(--unit);
  border: 1px solid var(--c-nd-200);
  background: var(--c-nd-100);
`;

const OfflineIcon = styled.div`
  opacity: 0.7;
`;

const Message = styled(BodyS)`
  flex: 1;
`;

const CloseButton = styled.div`
  align-self: flex-start;
`;

export const NetworkInfo = () => {
  const [offline, setIsOffline] = useState(false);
  const [shouldBeClosed, setShouldBeClosed] = useState(false);

  const { isMobileApp } = useIsMobileApp();

  useEffect(() => {
    function onlineHandler() {
      setIsOffline(false);
    }

    function offlineHandler() {
      setIsOffline(true);
    }

    window.addEventListener('online', onlineHandler);
    window.addEventListener('offline', offlineHandler);

    return () => {
      window.removeEventListener('online', onlineHandler);
      window.removeEventListener('offline', offlineHandler);
    };
  }, []);

  if (isMobileApp) {
    return null;
  }

  if (!offline) {
    if (shouldBeClosed) {
      setShouldBeClosed(false);
    }
    return null;
  }

  if (shouldBeClosed) {
    return null;
  }

  return (
    <Popup>
      <Wrapper>
        <OfflineIcon>
          <FontAwesomeIcon icon={faWifiSlash} />
        </OfflineIcon>
        <Message>
          <FormattedMessage
            id="NetworkInfo.message"
            defaultMessage="You're offline. Most actions might not work"
          />
        </Message>
        <CloseButton>
          <IconButton
            color="transparent"
            size="small"
            icon={faTimes}
            onClick={() => {
              setShouldBeClosed(true);
            }}
          />
        </CloseButton>
      </Wrapper>
    </Popup>
  );
};
